// extracted by mini-css-extract-plugin
export default {"header":"browser_update_header__Zltc7","icon":"browser_update_icon__S_dTK","notification":"browser_update_notification__Z-53c"};